import React from "react";
import styles from "./styles";
import CloseIcon from "@material-ui/icons/Close";
import {
  DialogActions,
  Button,
  DialogContent,
  Dialog,
  IconButton,
  withStyles,
} from "@material-ui/core";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import appConstants from "../../../../../../appConstants";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import CustomConfirmationDialog from "../common/CustomConfirmationDialog";
import { formatAddress } from "../../../utils/utils";
import { withSnackbar } from "notistack";
import { postData } from "../../../../../../api/componentAPIs";
import { trackEvent } from "../../../../../common/AppInsightsEventTracking";
import Events from "../../../../../../utilities/EventEmitter";
import Card from "./Card";
import ConfirmationDialogContent from "./ConfirmationDialogContent";
import Error from "../common/Error";
const LoaderDialog = React.lazy(() =>
  import("../../../../../header/dispatchHeader/DispatchLoader")
);
const dialogStyles = (theme) => ({
  root: {
    margin: 0,
    marginBottom: 0,
    padding: 16,
  },
  closeButton: {
    position: "absolute",
    right: 8,
    top: 16,
    color: theme.iconColor,
  },
});

const DialogTitle = withStyles(dialogStyles)((props) => {
  const { children, classes, onClose, handleClose, ...other } = props;
  return (
    <div>
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        {children}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </MuiDialogTitle>
    </div>
  );
});

class RemoveProDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removeProId: null,
      removeProInProgress: false,
      removeProErrorData: { message: "", proIds: [] },
    };
    this.timer = null;
    this.container = React.createRef();
  }

  componentDidMount() {
    Events.on("proDeleted", this.checkRemoveProEventStatus);
  }

  componentWillUnmount() {
    Events.off("proDeleted", this.checkRemoveProEventStatus);
  }

  handleRemovePro = (proId) => () => {
    this.setState({
      removeProId: proId,
    });
  };

  cancelRemovePro = () => {
    this.setState({
      removeProId: null,
    });
  };

  handleError = (errorMessage) => {
    this.props.enqueueSnackbar(errorMessage, { variant: "error" });
  };

  getRemoveProRequestObject = () => {
    const { routeData, userData } = this.props;
    return {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      routeId: routeData.routeId,
      proId: this.state.removeProId,
    };
  };

  checkRemoveProEventStatus = (data) => {
    const { success, proIds, message } = data;
    const { routeData } = this.props;
    if (success) {
      this.props.enqueueSnackbar(
        `Pro #${proIds.join(",")} removed from driver ${routeData.driverName}`,
        {
          variant: "success",
        }
      );
      this.props.handleClose();
    } else {
      this.handleError(`Failed to remove pro #${proIds.join(",")}`);
      this.setState({
        removeProInProgress: false,
        removeProId: null,
        removeProErrorData: { message, proIds },
      });
    }
    clearTimeout(this.timer);
  };

  onRemoveProProgressTimeOut = () => {
    this.timer = setTimeout(() => {
      this.setState({ removeProInProgress: false });
    }, appConstants.ONE_MINUTE_TIME_OUT);
  };

  removePro = () => {
    const requestObj = this.getRemoveProRequestObject();
    this.setState(
      {
        removeProInProgress: true,
        removeProId: null,
      },
      this.onRemoveProProgressTimeOut
    );
    trackEvent("Remove_Pro", this.props.userProfile, {
      event: "Remove_Pro",
      eventData: requestObj,
    });
    postData("RemovePro", requestObj).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) !== 2) {
          this.handleError(`Failed to remove pro #${requestObj.proId}`);
          this.setState({
            removeProInProgress: false,
          });
        }
      },
      () => {
        this.handleError(`Failed to remove pro #${requestObj.proId}`);
        this.setState({
          removeProInProgress: false,
        });
      }
    );
  };

  render() {
    const { classes, open, handleClose, stopData, routeData } = this.props;
    const { theme } = this.props.userData.userProfile || {};
    return (
      <React.Fragment>
        <Dialog
          aria-labelledby="customized-dialog-title"
          open={open}
          classes={{ paper: classes.dialog }}
          className={`${classes.dialogWrapper} ${
            theme === "dark" ? "darkTheme" : "lightTheme"
          } `}
        >
          <DialogTitle
            handleClose={handleClose}
            id="customized-dialog-title"
            className={classes.divider}
          >
            <div>
              <div>
                <span className={classes.stopName}>{stopData.name}</span>
              </div>
              <div>
                <span className={classes.stopAddress}>
                  {formatAddress({
                    address: stopData?.address,
                    address2: stopData?.address2,
                    city: stopData?.city,
                    state: stopData?.state,
                    zip: stopData?.zip,
                  })}
                </span>
              </div>
            </div>
          </DialogTitle>
          <DialogContent className="customScroll">
            <div>
              <h4
                className={classes.deliveryBillsHeaderText}
              >{`Delivery Bills: ${stopData.numberOfBills}`}</h4>
              {stopData.shipments.map((shipment) => {
                return (
                  <>
                    <Card
                      shipmentData={shipment}
                      key={`removePro_card${shipment.proId}`}
                      handleRemovePro={this.handleRemovePro}
                    />
                    {this.state.removeProErrorData.proIds.includes(
                      shipment.proId
                    ) && (
                      <div className={classes.errorContainer}>
                        <Error
                          label="Remove Pro Error"
                          message={this.state.removeProErrorData.message}
                        />
                      </div>
                    )}
                  </>
                );
              })}
            </div>
          </DialogContent>
          <DialogActions className={classes.dialogFooter}>
            <Button
              autoFocus
              onClick={handleClose}
              color="primary"
              variant="outlined"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        {Boolean(this.state.removeProId) && (
          <CustomConfirmationDialog
            title="Remove Pro"
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Remove Pro"
            onConfirm={this.removePro}
            onCancel={this.cancelRemovePro}
            mode="danger"
          >
            <ConfirmationDialogContent
              proId={this.state.removeProId}
              routeData={routeData}
            />
          </CustomConfirmationDialog>
        )}
        {this.state.removeProInProgress && (
          <LoaderDialog
            container={this.container.current}
            eventName="Remove pro"
          />
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar
)(RemoveProDialog);
